import { Component, OnInit, ViewChild } from '@angular/core';
import { AppConfig } from '../../../../app.config';
import { NotificationService } from '../../../../services/notification.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { HelpersService } from '../../../../services/helpers.service';
import { BroadcastService } from '../../../../services/broadcast.service';
import { UpdateJobcardComponent } from '../../../modals/update-jobcard/update-jobcard.component';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Paginator } from 'primeng/paginator';
import { CollectionsV2Service } from '../../../../services/collectionsV2.service';
import { NewJobcardService } from '../../../../services/new-jobcard.service';

@Component({
  selector: 'app-job-card-messages',
  templateUrl: './job-card-messages.component.html',
  styleUrls: ['./job-card-messages.component.scss'],
})
export class JobCardMessagesComponent implements OnInit {
  public loading = true;
  public search: string = '';
  public partnerID: number = 0;
  public partner: any = {};
  public notifications: any = [];
  public page: number = 0;
  public limit: number = 20;
  public totalRecords: number = 0;
  public columns: any = [
    { header: '', field: 'MessageRead', type: 'readStatus' },
    {
      header: this.translate.instant('general.headers.job_card'),
      field: 'JobCardNo',
      type: 'jobcardno',
    },
    {
      header: this.translate.instant('general.headers.cyclist'),
      field: 'User',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.phone'),
      field: 'PhoneNumber',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.message'),
      field: 'Message',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.received'),
      field: 'CreatedDate',
      type: 'date',
    },
    {
      header: this.translate.instant('general.headers.status'),
      field: 'JobCardStatusID',
      type: 'status',
    },
  ];
  public countryData: any = {};

  @ViewChild('paginator') paginator: Paginator;

  public loadingPartners = false;
  public linkedPartners: any = [];
  public selectedPartners: any = [];
  public selectedPartnerIds: any = [];
  public isAdmin = false;
  public isWorkshopManager = false;

  constructor(
    private appConfig: AppConfig,
    private notificationService: NotificationService,
    private helpersService: HelpersService,
    private serviceRequest: ServiceRequestService,
    public modalService: NgbModal,
    public broadcastService: BroadcastService,
    private translate: TranslateService,
    public collectionsV2Service: CollectionsV2Service,
    public newJobcardService: NewJobcardService,
  ) {
    this.partnerID = this.helpersService.getPartnerId();
    this.partner = this.helpersService.getPartnerData();
  }

  ngOnInit() {
    this.selectedPartnerIds = [this.partnerID];
    this.countryData = this.helpersService.getCountryData();
    this.getNotifications();

    this.isAdmin = this.helpersService.isAdminUser();
    this.isWorkshopManager = this.helpersService.isWorkshopManagerUser();

    this.getLinkedEnabledPartners();
  }

  getLinkedEnabledPartners() {
    if (!(this.isAdmin || this.isWorkshopManager)) {
      return;
    }
    this.loadingPartners = true;
    this.collectionsV2Service
      .getAllLinkedPartners(this.partnerID)
      .subscribe(
        (res) => {
          console.log(res);
          this.linkedPartners = res;
          this.loadingPartners = false;

          this.selectedPartners.push(
            this.linkedPartners.find((y) => y.partnerID == this.partnerID),
          );
          if (this.linkedPartners.length > 1) {
            this.columns.unshift({
              header: this.translate.instant(
                'bikeshop.shop_profile.collections.store_name',
              ),
              field: 'PartnerName',
              type: 'string',
            });
          }
        },
        (err) => {
          this.loadingPartners = false;
        },
      );
  }

  updateFilter(partner) {
    this.selectedPartnerIds = partner.map((x) => {
      return x.partnerID;
    });
    this.selectedPartners = partner;
    console.log(this.selectedPartnerIds);
    console.log(this.selectedPartners);
    this.getNotifications();
  }

  getNotifications() {
    this.loading = true;

    this.notificationService
      .getAllIncommingNotifications_V2(
        this.selectedPartnerIds.join(','),
        this.page,
        this.limit,
        '',
      )
      .subscribe(
        (res) => {
          console.log(res);
          this.loading = false;
          this.notifications = res.notifications.map((x) => {
            return { ...x, CreatedDate: x.CreatedDate + 'Z' };
          });
          this.totalRecords = res.count;
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  paginate(event) {
    this.page = event.page;
    this.limit = event.rows;
    this.getNotifications();
  }

  openJobCard(jobcardID, notification) {

    if (this.partner.UseNewJobCard) {
      this.newJobcardService.openManageJobCard(jobcardID, {
        onRefreshEvents: () => {
          if (this.search !== '') {
            this.searchMessages();
          } else {
            this.getNotifications();
          }
        }
      });
      if (!notification.MessageRead) {
        this.markAsRead(notification.ID, notification.PartnerID);
      }
      return;
    }


    const modalRef = this.modalService.open(UpdateJobcardComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'jobcard-modal',
    });
    modalRef.componentInstance.jobcard = null;
    modalRef.componentInstance.jobcardID = jobcardID;
    modalRef.componentInstance.partnerID = notification.PartnerID;
    modalRef.result.then(
      (result) => {
        if (this.search !== '') {
          this.searchMessages();
        } else {
          this.getNotifications();
        }
      },
      (onrejected) => {
        if (this.search !== '') {
          this.searchMessages();
        } else {
          this.getNotifications();
        }
      },
    );
    if (!notification.MessageRead) {
      this.markAsRead(notification.ID, notification.partnerID);
    }
  }

  searchMessages() {
    if (this.search === '') {
      if (this.page > 0) {
        this.paginator.changePageToFirst({ page: 0, rows: this.limit } as any);
        //todo:(dcorbett) : this has to be of type any
      } else {
        this.getNotifications();
      }
    } else {
      this.notificationService
        .getAllIncommingNotifications_V2(
          this.selectedPartnerIds.join(','),
          0,
          this.limit,
          this.search,
        )
        .subscribe(
          (res) => {
            this.loading = false;
            this.notifications = res.notifications;
            this.totalRecords = res.count;
          },
          (err) => {
            this.loading = false;
          },
        );
    }
  }

  getStatusDescription(statusID) {
    var status = this.appConfig
      .getStatusList()
      .filter((x) => {
        return x.id === statusID;
      })
      .pop();
    return statusID === 0 ? 'All' : status ? status.label : ' - ';
  }

  markAsRead(messageID, partnerID) {
    var message = this.notifications
      .filter((message) => {
        return message.ID === messageID;
      })
      .pop();
    message.MessageRead = true;
    this.notificationService
      .markMessageRead(partnerID, messageID)
      .subscribe(() => {
        this.getNotifications();
        this.broadcastService.sendMessage({ updateNotifications: true });
      });
  }
}
